import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
import { passFailState, passFailMutations } from '@/../../troubleshooter/src/store/common/passFail'
// import { getFromLocalStorage } from '../plugins/localStorage'
import { defaultMediaOpts, twilioMediaInput } from '@/../../shared/src/utils/twilioHelpers'


export default {
  namespaced: true,
  state: {
    ...passFailState,
    explainer: [
      _('Finally, let\'s test your video and audio quality to ensure you have a great experience in the classroom.'),
      _('You\'ll see the results in just 30 seconds.'),
      _(' Please do not leave this page.')
    ],
    title: _('Step 5: Class Quality Test'),
    nextPage: '/home/',
    previousPage: '#/connection/',
    callToAction: {
      'text': _('Test Class Quality')
    },
    questionId: 'preview',
    videoProvider: 'twilio',
    twilioMediaOpts: defaultMediaOpts(),
    opentokMediaOpts: {}
  },

  mutations: {

    ...passFailMutations,

    changeVideoProvider (state, payload) {
      state.videoProvider = payload.videoProvider
    },

    twilioChangeMediaDevice (state, payload) {
      if (payload.deviceId === 'disabled') {
        state.twilioMediaOpts[payload.inputType] = false
      } else {
        state.twilioMediaOpts[payload.inputType] = Object.assign(defaultMediaOpts()[payload.inputType], {'deviceId': {'exact': payload.deviceId}})
      }
    },

    opentokChangeMediaDevice (state, payload) {
      console.log('Change opentok device')
    }

  },

  actions: {

    changeMediaDevice ({state, commit}, payload) {
      commit(`${state.videoProvider}ChangeMediaDevice`, payload)
    }
  },

  getters: {
    audioInput (state, getters) {
      if (state.videoProvider === 'twilio') {
        return twilioMediaInput(state.twilioMediaOpts, 'audio')
      }
    },
    videoInput (state, getters) {
      if (state.videoProvider === 'twilio') {
        return twilioMediaInput(state.twilioMediaOpts, 'video')
      }
    },

    mediaOpts (state, getters) {
      return state[`${state.videoProvider}MediaOpts`]
    }
  }
}

// function twilioMediaInput (options, media) {
//   if (!options[media]) {
//     return 'disabled'
//   } else if (options[media].deviceId === undefined) {
//     return ''
//   } else {
//     return options[media].deviceId.exact
//   }
// }


